<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue';

interface StoryblokChild {
    _uid: string;
}

interface StepsSectionBlok {
    _uid: string;
    headline: string;
    subline: string;
    steps: StoryblokChild[];
    background_color: string;
}

defineProps<{ blok: StepsSectionBlok }>();
</script>

<template>
    <section
        v-editable="blok"
        class="py-16 font-quicksand xl:py-24"
        :class="
            blok.background_color === 'warm'
                ? 'bg-[#FCEEE6]'
                : blok.background_color === 'light'
                  ? 'bg-[#FCF7F4]'
                  : 'bg-white'
        "
    >
        <div class="mx-auto flex max-w-[1440px] flex-col px-4">
            <div v-if="blok.headline || blok.subline" class="mx-auto mb-12 max-w-3xl text-center xl:mb-16">
                <h2 v-if="blok.headline" class="text-[28px] font-semibold leading-tight text-[#004646] xl:text-4xl">
                    {{ blok.headline }}
                </h2>
                <p v-if="blok.subline" class="mt-4 text-base font-normal text-[#393734] xl:text-xl">
                    {{ blok.subline }}
                </p>
            </div>
            <div class="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8 xl:gap-12">
                <StoryblokComponent v-for="step in blok.steps ?? []" :key="step._uid" :blok="step" />
            </div>
        </div>
    </section>
</template>
